import React, { useState, useEffect } from "react";
import axios from '../Axiosinstance';
import Header from '../components/Header';

import 'bootstrap/dist/css/bootstrap.min.css';
import {
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    TablePagination,
    Grid,
} from '@mui/material';
import Certificate from '../components/Certificate';
import CourseCompletion from '../components/CourseCompletion';

const Student = () => {
    const [open, setOpen] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState({});
    const [paymentMode, setPaymentMode] = useState('');
    const [filter, setFilter] = useState('complete');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [students, setStudents] = useState([]);
    const [letterType, setLetterType] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [sessionId, setSessionId] = useState(null);
    const [loading, setLoading] = useState(false); // Add loading state

    const handleClickOpen = (student) => {
        setSelectedStudent(student);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedStudent({});
        setPaymentMode('');
    };

    const handleOpenModal = (type, id) => {
        setLetterType(type);
        setSessionId(id);
        setShowModal(true);
    };

    const handlePaymentModeChange = (event) => {
        setPaymentMode(event.target.value);
    };



    const handleCloseModal = () => {
        setShowModal(false);
    };

    const fetchData = async (filterValue) => {
        setLoading(true); // Start loading
        try {
            const endpoint = filterValue === 'complete'
                ? '/registrationadvances/Students/alumni/Paid'
                : '/registrationadvances/pending/registrations/alumni';
            const response = await axios.get(endpoint);
            setStudents(response.data); // Update students with data if available
        } catch (error) {
            if (error.response && error.response.status === 404) {
                // Handle 404 error: Set students to an empty array if no data is found
                setStudents([]);
            } else {
                console.error('Error fetching data:', error);
            }
        } finally {
            setLoading(false); // End loading
        }
    };

    const handleFilterChange = (event) => {
        const newFilter = event.target.value;
        setFilter(newFilter);
        setPage(0); // Reset to first page on filter change
        fetchData(newFilter); // Fetch new data based on filter
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        fetchData(filter); // Fetch data on component mount or filter change
    }, []);
    return (
        <div>
            <Header />
            <br />
            <div className="container-fluid" style={{ maxWidth: '1200px', marginTop: '20px' }}>
                <h2 className="heading" align="center" style={{ color: '#FFFFFF', fontSize: '28px', marginTop: '35px' }}>
                    Alumni Details
                </h2>

                <Grid container justifyContent="center" style={{ marginBottom: '20px' }}>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth margin="dense" variant="outlined">
                            <InputLabel>Filter Payments</InputLabel>
                            <Select
                                value={filter}
                                onChange={handleFilterChange}
                                label="Filter Payments"
                            >
                                <MenuItem value="complete">Alumni Payments Complete</MenuItem>
                                <MenuItem value="incomplete">Alumni Payments Incomplete</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>

                <Paper>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>S.no</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Phone</TableCell>
                                    <TableCell>Gender</TableCell>
                                    <TableCell>NRIC</TableCell>
                                    <TableCell>Overall Start Date</TableCell>
                                    <TableCell>Overall End Date</TableCell>
                                    {/* <TableCell>Address</TableCell> */}
                                    <TableCell>Status</TableCell>
                                    <TableCell>Date of Birth</TableCell>
                                    {filter === 'incomplete' && <TableCell>Action</TableCell>}
                                     
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {students
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((student, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                            <TableCell>{student.studentName}</TableCell>
                                            <TableCell>{student.email}</TableCell>
                                            <TableCell>{student.phone}</TableCell>
                                            <TableCell>{student.gender}</TableCell>
                                            <TableCell>{student.nric}</TableCell>
                                            <TableCell>{student.overallStartDate}</TableCell>
                                            <TableCell>{student.overallEndDate}</TableCell>
                                            <TableCell>{student.status}</TableCell>
                                            <TableCell>{student.dob}</TableCell>
                                            <TableCell>
                                                {filter === 'incomplete' && (
                                                    <Button variant="contained" color="primary" onClick={() => handleClickOpen(student)}>
                                                        Pay
                                                    </Button>
                                                )}
                                                
                                            </TableCell>


                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 15]}
                        component="div"
                        count={students.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
                <Dialog open={showModal} onClose={handleCloseModal} fullScreen>
                    <DialogTitle>
                        {letterType === 'CourseCompletion' ? 'Course Completion' : 'Certificate'}
                        <Button
                            onClick={handleCloseModal}
                            style={{
                                position: 'absolute',
                                right: '8px',
                                top: '8px',
                                minWidth: 'unset',
                                padding: '8px',
                                fontSize: '1.5rem',
                            }}
                        >
                            X
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                        {letterType === 'CourseCompletion' && <CourseCompletion sessionId={sessionId} />}
                        {letterType === 'Certificate' && <Certificate sessionId={sessionId} />}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseModal} color="secondary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle>Payment Details</DialogTitle>
                    <DialogContent>
                        <TextField
                            margin="dense"
                            label="Name"
                            type="text"
                            fullWidth
                            value={selectedStudent.studentName || ''}
                            disabled
                        />
                        <TextField
                            margin="dense"
                            label="Amount"
                            type="number"
                            fullWidth
                            value={selectedStudent.amountPending || ''}
                            disabled
                        />
                        <FormControl fullWidth margin="dense">
                            <InputLabel>Mode of Payments</InputLabel>
                            <Select
                                value={paymentMode}
                                onChange={handlePaymentModeChange}
                                label="Mode of Payments"
                            >
                                <MenuItem value="Cash">Cash</MenuItem>
                                <MenuItem value="Card">Card</MenuItem>
                                <MenuItem value="Netbanking">Netbanking</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            margin="dense"
                            label="Remarks"
                            type="text"
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={handleClose} color="primary">
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
};

export default Student;
